
export enum FAQ_CATEGORIES {
    FILE_IMPORT_AND_FILE_ORGANISATION = 'File import',
    TEAM = 'Teams',
    SHARING_FILES = 'Sharing files',
    SUBSCRIPTIONS = 'Subscriptions',
    ACCOUNT_MANAGEMENT = 'Account management',
    INSTALLATION_AND_ACCESS = 'Installation and access',
    SEQUENCE_EDITING = 'Sequence editing',
    FEATURES = 'Features',
    PRIMERS = 'Primers',
    CLONING = 'Cloning',
    CRISPR = 'CRISPR',
    ALIGNMENT = 'Alignment',
    ENZYMES = 'Enzymes',
    GENOME_BROWSER = 'Genome browser',
    VIEW_AND_DISPLAY = 'View and display',
    LIBRARY = 'Library',
    WHATS_NEW = "What's new",
}

export type FAQ = {
  title: string;
  description: string;
  subDescription?: string[];
  mainDescription?: string[];
  tags: FAQ_CATEGORIES[];
}

export const FAQS: FAQ[] = [
    {
        title: 'Can I import my current files?',
        description: 'Yes, drag and drop (formats: .dna, .gb, .gbk, .fasta, .geneious, .sbol, .ab1) into Photo51. Your folder structure will be preserved. You can also use the Import button in the ribbon.',
        tags: [FAQ_CATEGORIES.FILE_IMPORT_AND_FILE_ORGANISATION]
    }, {
        title: 'What is a Team?',
        description: 'A Team allows you to collaborate with others—your lab, a project group, or a Team',
        subDescription: [
          'Each Team shares access to their file inventory.',
          'Subscribed members have full access.',
          'Non-subscribed members use the Free View-Only plan.',
        ],
        tags: [FAQ_CATEGORIES.TEAM]
    }, {
        title: 'How can I create a Team?',
        description: 'You can access Teams from both your desktop and browser. From the desktop application, click Manage Teams in your files directory on the left. This opens the browser where you can create and manage Teams. You can also go to fearlessleague.com and click My Teams in the left menu. \n' +
            'You can create multiple Teams at once. Share unique URLs to invite members or add members directly to a Team.',
        tags: [FAQ_CATEGORIES.TEAM]
    },  {
        title: 'How do I add members to a Team?',
        description: 'Team management is done in the browser. Go to My Teams in the left menu and invite members by email.',
        tags: [FAQ_CATEGORIES.TEAM]
    },  {
        title: 'Can I be a member of multiple Teams?',
        description: 'Yes',
        tags: [FAQ_CATEGORIES.TEAM]
    },  {
        title: 'Can I make a Team if I have a View-Only subscription?',
        description: 'Yes. You’ll be able to view, share, and download files – but not edit them.',
        tags: [FAQ_CATEGORIES.TEAM]
    },  {
        title: 'How can I share files?',
        description: 'You can share files from within the Photo51 application.',
        subDescription: [
          'Search for a registered user by name.',
          'Share with non-users by entering their email address. They’ll be prompted to sign up. Upon sign-up, they’ll receive a free trial and full access to the shared files.',
        ],
        tags: [FAQ_CATEGORIES.SHARING_FILES]
    }, {
        title: 'Can I share a file with a user who does not have a subscription? ',
        description: 'Yes. They’ll automatically be enrolled in the free View-Only plan after the trial. They can view your files but not edit them.',
        tags: [FAQ_CATEGORIES.SHARING_FILES]
    }, {
        title: 'Can I share a file with someone who does not have a Photo51 account? ',
        description: 'Yes. You can share files from Photo51 by entering their email address. After signing up, they’ll receive a free trial and have full access to the shared files.',
        tags: [FAQ_CATEGORIES.SHARING_FILES]
    }, {
        title: 'What does the free trial period include?',
        description: 'You’ll get full access to Photo51 during your trial—no restrictions.',
        tags: [FAQ_CATEGORIES.SUBSCRIPTIONS]
    },
    {
        title: 'What is the view-only Plan?',
        description: 'After your free trial ends, you’ll automatically switch to the free View-Only plan. You can still view, share, and download files—but not edit them.',
        tags: [FAQ_CATEGORIES.SUBSCRIPTIONS]
    }, {
        title: 'Can I create a Team without a subscription?',
        description: 'Yes. But only members with a paid subscription will have full access to Photo51 features. Others will remain on the View-Only plan.',
        tags: [FAQ_CATEGORIES.SUBSCRIPTIONS]
    }, {
        title: 'How do I join a Team?',
        description: 'You’ll need to be invited. Once you accept, you’ll occupy one of that Team’s seats. If you\'re invited to multiple Teams, you choose which Team’s seat to occupy.',
        tags: [FAQ_CATEGORIES.SUBSCRIPTIONS]
    }, {
        title: 'I have an Individual subscription and want to join a Team. What happens to my subscription?',
        description: 'You can choose whether to transfer your subscription to the Team or keep your Individual subscription.',
        tags: [FAQ_CATEGORIES.SUBSCRIPTIONS]
    }, {
        title: 'I’m already part of a Team and got invited to another. What happens to my subscription?',
        description: 'You choose which Team’s seat to occupy. If you’re unsure which to select, contact the Team administrator.',
        tags: [FAQ_CATEGORIES.SUBSCRIPTIONS]
    }, {
        title: 'Can I belong to more than one Team?',
        description: 'Yes. You can join and create as many Teams as you like. You’ll occupy only one Team’s seat for your subscription at a time.',
        tags: [FAQ_CATEGORIES.SUBSCRIPTIONS]
    }, {
        title: 'What happens when my subscription or trial expires?',
        description: 'Your account becomes View-Only. You can still view, share, download, and export your files anytime.',
        tags: [FAQ_CATEGORIES.SUBSCRIPTIONS]
    }, {
        title: 'When can I cancel?',
        description: 'Anytime. If billed monthly, your full access continues until the end of the current billing period.\n'
          + 'Example: If you’re billed on the 1st and cancel on June 5, you’ll retain access until June 30.',
        tags: [FAQ_CATEGORIES.SUBSCRIPTIONS]
    }, {
        title: 'How are Team Subscriptions charged?',
        description: 'Team Subscriptions require a minimum of 2 seats and are billed annually. The Team admin invites users, and each accepted invite occupies one seat.\n'
          +'If you\'re invited to join and already have a subscription, you can choose whether to switch billing to that Team or keep your current plan. No matter which paid subscription type you use, you’ll have full feature access.',
        tags: [FAQ_CATEGORIES.SUBSCRIPTIONS]
    }, {
        title: 'What’s the difference between an Individual Subscription and a Team Subscription?',
        description: 'If you’re part of multiple Teams or subscriptions, you can select which one pays for your access under My Subscription. \n'
          + 'If unsure, check with your Team admin.',
        mainDescription: [
            'Individual Subscription: You manage and pay for your own plan.',
            'Team Subscription: A group pays. Members occupy a seat and don’t pay individually.'
        ],
        tags: [FAQ_CATEGORIES.SUBSCRIPTIONS]
    }
];
